<template>
    <div class="chat-group-card" @click.stop="onShowGroupInfo">
        <div class="card-body">
            <head-image :url="cardInfo.headImage" :name="cardInfo.groupName" radius="10%" variant="group"></head-image>
            <div class="nick-name">
                {{ cardInfo.groupName }}
            </div>
        </div>
        <div class="card-footer">
            <div class="tip">群名片</div>
            <el-tag v-if="isExpired" type="warning">已过期</el-tag>
        </div>
    </div>
</template>
<script>
import HeadImage from '../common/HeadImage.vue'

export default {
    name: "chatUserCard",
    components: {
        HeadImage
    },
    props: {
        sendTime: {
            type: Number,
            default: null
        },
        cardInfo: {
            type: Object
        }
    },
    data() {
        return {}
    },
		methods: {
			onShowGroupInfo(e) {
				if (this.isExpired) {
					this.$message.warning('该名片已过期')
					return;
            }
            if (!this.cardInfo || !this.cardInfo.groupId) {
                this.$message.warning('群名片信息不完整');
                return;
            }
				const pos = this.buildCardPos(e);
				this.$http({
					url: `/group/find/${this.cardInfo.groupId}`,
					method: 'get'
				}).then(group => {
					this.$eventBus.$emit("openGroupInfo", this.mergeGroupInfo(group), this.cardInfo.token, pos);
				}).catch(error => {
					console.warn('刷新群名片资料失败:', error);
					this.$eventBus.$emit("openGroupInfo", this.buildFallbackGroup(), this.cardInfo.token, pos);
				})
			},
        buildCardPos(e) {
            return {
                x: e.x + 30,
                y: e.y
            }
        },
        buildFallbackGroup() {
            const card = this.cardInfo || {};
            const storeGroup = this.groupStore && card.groupId ? this.groupStore.findGroup(card.groupId) : null;
            const groupName = card.groupName || (storeGroup && (storeGroup.showGroupName || storeGroup.name)) || '群名片';
            const headImage = card.headImage || (storeGroup && (storeGroup.headImageThumb || storeGroup.headImage)) || '';
            return {
                ...(storeGroup || {}),
                id: card.groupId,
                name: groupName,
                showGroupName: groupName,
                headImage,
                headImageThumb: headImage,
                memberCount: (storeGroup && storeGroup.memberCount) || 0
            }
        },
        mergeGroupInfo(group) {
            const fallbackGroup = this.buildFallbackGroup();
            const nextGroup = {
                ...fallbackGroup,
                ...(group || {})
            };
            nextGroup.name = nextGroup.name || fallbackGroup.name;
            nextGroup.showGroupName = nextGroup.showGroupName || nextGroup.remarkGroupName || nextGroup.name;
            nextGroup.headImageThumb = nextGroup.headImageThumb || nextGroup.headImage || fallbackGroup.headImageThumb;
            nextGroup.headImage = nextGroup.headImage || nextGroup.headImageThumb || fallbackGroup.headImage;
            return nextGroup;
        }
    },
    computed: {
        isExpired() {
            if (!this.cardInfo.token || !this.cardInfo.token.expiredIn) {
                return true;
            }
            return new Date().getTime() > this.cardInfo.token.expiredIn
        }
    }
}
</script>
<style scoped lang="scss">
.chat-group-card {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    background: var(--im-control-soft-bg);
    border-radius: 6px;
    padding: 10px 12px;
    height: 90px;
    width: min(100%, 200px);
    max-width: 100%;
    cursor: pointer;
    border: 1px solid var(--im-control-border);
    transition: border-color 0.2s ease, background-color 0.2s ease;
    position: relative;
    overflow: hidden;
    text-align: left;
    box-sizing: border-box;

    &:hover {
        border-color: rgba(var(--im-primary-rgb), 0.2);
        background: rgba(var(--im-primary-rgb), 0.06);
    }

    .card-body {
        flex: 1;
        display: flex;
        align-items: center;
        gap: 10px;
        border-bottom: 1px solid rgba(var(--im-black-rgb), 0.06);
        padding-bottom: 8px;

        .nick-name {
            flex: 1;
            min-width: 0;
            font-weight: 600;
            font-size: 15px;
            color: var(--im-text-color-primary);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 1.3;
        }
    }

    .card-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 6px;
        width: 100%;
        color: var(--im-text-color-light);
        font-size: 12px;
        text-align: left;

        .tip {
            flex: 1;
            font-weight: 500;
            color: var(--im-text-color-light);
        }
    }
}
</style>
